//biome-ignore-all lint/suspicious/noShadowRestrictedNames: migrtating
import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function Number(props: SystemIconProps) {
  const { isSystem } = props;

  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="NumberIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#C0E6CB" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0819 15.6662L12.6894 12.3329H15.9186L15.3111 15.6662H12.0819ZM20.6669 15.6662H17.0819L17.6894 12.3329H20.6669C21.1252 12.3329 21.5002 11.9579 21.5002 11.4995C21.5002 11.0412 21.1252 10.6662 20.6669 10.6662H17.9919L18.5702 7.49037C18.6536 7.03371 18.3352 6.59287 17.8627 6.51287C17.3902 6.43204 16.9361 6.74037 16.8527 7.19787L16.2211 10.6662H12.9919L13.5702 7.49037C13.6536 7.03371 13.3352 6.59287 12.8627 6.51287C12.3902 6.43204 11.9361 6.74037 11.8527 7.19787L11.2211 10.6662H7.33358C6.87524 10.6662 6.50024 11.0412 6.50024 11.4995C6.50024 11.9579 6.87524 12.3329 7.33358 12.3329H10.9186L10.3111 15.6662H7.33358C6.87524 15.6662 6.50024 16.0412 6.50024 16.4995C6.50024 16.9579 6.87524 17.3329 7.33358 17.3329H10.0077L9.42941 20.5087C9.34691 20.9654 9.66524 21.4062 10.1377 21.4862C10.6094 21.567 11.0644 21.2587 11.1469 20.8012L11.7786 17.3329H15.0077L14.4294 20.5087C14.3469 20.9654 14.6652 21.4062 15.1377 21.4862C15.6094 21.567 16.0644 21.2587 16.1469 20.8012L16.7786 17.3329H20.6669C21.1252 17.3329 21.5002 16.9579 21.5002 16.4995C21.5002 16.0412 21.1252 15.6662 20.6669 15.6662Z"
          fill="#539868"
        />
        <mask id="mask0_2984_257308" maskUnits="userSpaceOnUse" x="6" y="6" width="16" height="16">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0819 15.6662L12.6894 12.3329H15.9186L15.3111 15.6662H12.0819ZM20.6669 15.6662H17.0819L17.6894 12.3329H20.6669C21.1252 12.3329 21.5002 11.9579 21.5002 11.4995C21.5002 11.0412 21.1252 10.6662 20.6669 10.6662H17.9919L18.5702 7.49037C18.6536 7.03371 18.3352 6.59287 17.8627 6.51287C17.3902 6.43204 16.9361 6.74037 16.8527 7.19787L16.2211 10.6662H12.9919L13.5702 7.49037C13.6536 7.03371 13.3352 6.59287 12.8627 6.51287C12.3902 6.43204 11.9361 6.74037 11.8527 7.19787L11.2211 10.6662H7.33358C6.87524 10.6662 6.50024 11.0412 6.50024 11.4995C6.50024 11.9579 6.87524 12.3329 7.33358 12.3329H10.9186L10.3111 15.6662H7.33358C6.87524 15.6662 6.50024 16.0412 6.50024 16.4995C6.50024 16.9579 6.87524 17.3329 7.33358 17.3329H10.0077L9.42941 20.5087C9.34691 20.9654 9.66524 21.4062 10.1377 21.4862C10.6094 21.567 11.0644 21.2587 11.1469 20.8012L11.7786 17.3329H15.0077L14.4294 20.5087C14.3469 20.9654 14.6652 21.4062 15.1377 21.4862C15.6094 21.567 16.0644 21.2587 16.1469 20.8012L16.7786 17.3329H20.6669C21.1252 17.3329 21.5002 16.9579 21.5002 16.4995C21.5002 16.0412 21.1252 15.6662 20.6669 15.6662Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2984_257308)"></g>
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default Number;
